import React from "react";
import styled from "styled-components";
import { isClientSide } from "~/core/ssr";
import { BottomStickyBar } from "~/guidelines/StickyBar";
import mediaQueries from "~/guidelines/Theme/mediaQueries";

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const TopBar = styled.div`
  ${mediaQueries.md()} {
    position: sticky;
    top: 0;
    z-index: 2;
  }
`;

const Header = styled.div`
  order: 2;

  ${mediaQueries.md()} {
    order: 0;
  }
`;

const SearchRow = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`;

const ImageGalleryContainer = styled.div`
  position: relative;
  order: 1;

  ${mediaQueries.md()} {
    order: 0;
  }
`;

const ImageGallery = styled.div``;

const Content = styled.div`
  order: 3;

  ${mediaQueries.md()} {
    order: 0;
  }
`;

const Footer = styled.div`
  order: 4;

  ${mediaQueries.md()} {
    order: 0;
  }
`;

type OfferDetailsTemplateProps = {
  topBar: React.ReactNode;
  header?: React.ReactNode;
  searchRow?: React.ReactNode;
  imageGallery?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  stickyElement?: React.ReactNode;
  isStickBasVisible?: boolean;
};

const OfferDetailsTemplate = ({
  topBar,
  header,
  searchRow,
  imageGallery,
  children,
  footer,
  stickyElement,
  isStickBasVisible,
}: OfferDetailsTemplateProps) => {
  return (
    <Container>
      <TopBar>{topBar}</TopBar>
      <Header>{header}</Header>
      <ImageGalleryContainer>
        <SearchRow>{searchRow}</SearchRow>
        <ImageGallery>{imageGallery}</ImageGallery>
      </ImageGalleryContainer>
      <Content>{children}</Content>
      <Footer>{footer}</Footer>
      {stickyElement && isClientSide() && (
        <BottomStickyBar isVisible={isStickBasVisible}>
          {stickyElement}
        </BottomStickyBar>
      )}
    </Container>
  );
};

export default OfferDetailsTemplate;
